import { getPobbleEnv } from 'pobble-components/dist/utils'
import { apiClient } from 'pobble-components/dist/api'

const ENV = getPobbleEnv()
const ORIGIN = window.location.origin
const TWITTER_AUTH_PAGE =
  'https://api.twitter.com/oauth/authenticate?oauth_token='

const apiTwitterGetOauthToken = spa =>
  apiClient.get('/v3/twitter_authentication/obtain_oauth_token', {
    params: {
      callback_url:
        ENV === 'local'
          ? `${ORIGIN}/oauth-callback/twitter`
          : `${ORIGIN}/${spa}/oauth-callback/twitter`
    }
  })

const apiTwitterConnectIdentity = (data, params) =>
  apiClient.post('/v3/twitter_authentication/connect_oauth_identity', data, {
    params
  })

const apiTwitterAuthentication = (data, params) =>
  apiClient.post('v3/twitter_authentication', data, { params })

const startTwitterLoginProcess = spa =>
  apiTwitterGetOauthToken(spa).then(
    res => (window.location = TWITTER_AUTH_PAGE + res.data.oauth_token)
  )

const twitterCallback = params => {
  return new Promise((resolve, reject) => {
    if (params.denied) return reject('CANCEL')
    apiTwitterAuthentication(
      {
        oauth_token: params.oauth_token,
        verifier_token: params.oauth_verifier
      },
      {
        include: 'account.finish_signup_status'
      }
    )
      .then(resolve)
      .catch(reject)
  })
}

const twitterConnectCallback = params => {
  return new Promise((resolve, reject) => {
    if (params.denied) return reject('CANCEL')
    apiTwitterConnectIdentity({
      oauth_token: params.oauth_token,
      verifier_token: params.oauth_verifier
    })
      .then(resolve)
      .catch(reject)
  })
}

export { startTwitterLoginProcess, twitterCallback, twitterConnectCallback }
